import { render, staticRenderFns } from "./TagsWidget.vue?vue&type=template&id=46147173&"
import script from "./TagsWidget.vue?vue&type=script&lang=js&"
export * from "./TagsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports